class ActivityForm extends HTMLElement {
  constructor() {
    super();
    this.initElements();
    this.attachEventListeners();
  }

  initElements() {
    this.submitTitle = this.getAttribute("submittitle");
    this.submitDescription = this.getAttribute("submitdescription");
    this.addressSuggestions = this.querySelector("#address-suggestions");
    this.addressInput = this.querySelector("#address-input");
    this.submitButton = this.querySelector("#submit-button");
    this.submitButtonSpinner = this.querySelector(".submit-button-spinner");
    this.submitStateIndicator = document.getElementById("submit-state-indicator");
    this.form = this.querySelector("form");
    this.lastPickedAddressId = null;
    this.activeOptionIndex = -1;
    this.address = {};
    this.submitLoading = false;
    console.log(this.submitTitle);
    console.log(this.submitDescription);
  }

  attachEventListeners() {
    this.form.addEventListener("submit", (e) => this.validateForm(e));
    this.submitButton.addEventListener("click", (e) => this.validateForm(e));
    this.addressInput.addEventListener("input", this.debounce(this.handleInput.bind(this), 300));
    this.addressInput.addEventListener("keydown", (e) => this.handleKeydown(e));
    this.addressInput.addEventListener("blur", () => this.hideSuggestions());
    this.addressInput.addEventListener("focus", () => this.showSuggestions());
    this.addressSuggestions.addEventListener("mousedown", (e) => this.preventBlur(e));
  }

  validateForm(e) {
    e.preventDefault();
    const inputs = this.form.querySelectorAll("input, textarea");
    let isValid = true;
    let dateValue = "";
    let timeValue = "";

    inputs.forEach((input) => {
      if (input.checkValidity()) {
        this.clearError(input);
      } else {
        this.showError(input);
        isValid = false;
      }

      if (input.type === "date") {
        const parsedDateValue = Date.parse(input.value);
        if (isNaN(parsedDateValue)) {
          this.showError(input, "Indtast en gyldig dato");
          isValid = false;
        } else {
          dateValue = input.value;
        }
      }

      // if input is of type checkbox and is required
      if (input.type === "checkbox" && input.required && !input.checked) {
        this.showError(input, "Dette felt skal udfyldes");
        isValid = false;
      }

      if (input.type === "time") {
        const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        if (!timeRegex.test(input.value)) {
          this.showError(input, "Indtast en gyldig tid");
          isValid = false;
        } else {
          timeValue = input.value;
        }
      }

      if (input.id === "address-input" && this.address.type != null) {
        this.showError(input, "Indtast en gyldig adresse");
        isValid = false;
      }
    });

    if (!isValid) return;

    // Combine date and time into a single datetime string
    let datetime = null;
    if (dateValue && timeValue) {
      const combinedDateTime = new Date(`${dateValue}T${timeValue}`);
      datetime = combinedDateTime.toISOString();
    }

    const formData = new FormData(this.form);
    formData.delete("date"); // Remove the original date field
    formData.delete("time"); // Remove the original time field

    const data = Object.fromEntries(formData.entries());

    const createActivityRequest = {
      ...data,
      date: datetime, // Add the combined datetime field as 'date'
      streetName: this.address.StreetName,
      houseNumber: `${this.address.HouseNumber}`,
      floor: this.address.Floor,
      door: this.address.Door,
      city: this.address.City,
      zipCode: this.address.ZipCode,
      xCoordinate: this.address.XCoordinate,
      yCoordinate: this.address.YCoordinate,
    };

    console.log(createActivityRequest);
    this.sendActivityRequest(createActivityRequest);
  }

  showError(input, message = null) {
    let error = input.nextElementSibling;
    if (!error || error.tagName !== "P") {
      error = document.createElement("P");
      error.classList.add("text-red", "text-xs", "leading-4", "animate-fadeIn", "absolute", "-bottom-5", "left-0", "mt-1", "error-message", "opacity-100", "transition-opacity", "duration-300", "breakt");
      input.insertAdjacentElement("afterend", error);
    }
    error.textContent = message || input.validationMessage;
  }

  clearError(input) {
    const error = input.nextElementSibling;
    if (error && error.tagName === "P") {
      error.remove();
    }
  }

  async sendActivityRequest(createActivityRequest) {
    this.submitLoading = true;
    this.updateSubmitButtonState();

    try {
      const response = await fetch("/api/activities", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(createActivityRequest),
      });

      if (response.ok) {
        this.handleSuccess();
      } else {
        throw new Error(await response.text());
      }
    } catch (error) {
      this.handleError(error);
    } finally {
      this.submitLoading = false;
      this.updateSubmitButtonState();
    }
  }

  handleSuccess() {
    const successMessage = `
        <div class="animation-fade bg-green-100 px-4 py-3 absolute rounded left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" role="alert">
          <div class="flex flex-col items-center text-center gap-2">
            <svg class="w-18 h-18 text-green flex flex-col items-center justify-center mb-5 " width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="validation-check-circle 1" clip-path="url(#clip0_1189_10505)">
                <path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 8.8174 1.26428 5.76515 3.51472 3.51472C5.76515 1.26428 8.8174 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76515 24 8.8174 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.8174 24 5.76515 22.7357 3.51472 20.4853C1.26428 18.2348 0 15.1826 0 12ZM18.072 7.9944C18.273 7.6573 18.334 7.25482 18.2417 6.87333C18.1494 6.49183 17.9112 6.16171 17.5783 5.9538C17.2454 5.74589 16.8442 5.67675 16.4609 5.76121C16.0776 5.84568 15.7427 6.07702 15.528 6.4056L10.5264 14.4072L8.2608 12.1392C7.97946 11.8579 7.59788 11.6998 7.2 11.6998C6.80212 11.6998 6.42054 11.8579 6.1392 12.1392C5.85786 12.4205 5.6998 12.8021 5.6998 13.2C5.6998 13.397 5.73861 13.5921 5.814 13.7741C5.88939 13.9561 5.99989 14.1215 6.1392 14.2608L9.7392 17.8608C9.89864 18.0205 10.0921 18.1421 10.305 18.2166C10.518 18.2912 10.7451 18.3167 10.9693 18.2914C11.1935 18.266 11.4091 18.1903 11.6 18.0701C11.7909 17.9498 11.9523 17.7881 12.072 17.5968L18.072 7.9968V7.9944Z" fill="currentColor"/>
              </g>
              <defs>
                <clipPath id="clip0_1189_10505">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <h3 class="mb-4 text-2xl">${this.submitTitle}</h3>
            <p class="text-grey-600 text-center">${this.submitDescription}</p>
          </div>
        </div>
      `;
    this.form.querySelector(".form-fields").classList.add("opacity-0", "pointer-events-none");
    this.form.insertAdjacentHTML("beforeend", successMessage);
    this.resetForm();
  }

  handleError(error) {
    let errorJson = JSON.parse(error.message);
    console.log(errorJson);

    if (errorJson.errors.City[0] || errorJson.errors.ZipCode[0] || errorJson.errors.StreetName[0] || errorJson.errors.HouseNumber[0]) {
      this.showError(this.addressInput, "Indtast en gyldig adresse");
    } else if (this.submitStateIndicator) {
      this.submitStateIndicator.textContent = "Der skete en fejl. Prøv igen senere.";
      // make it red and show error icon
      this.submitStateIndicator.classList.add("text-red");
    }
  }

  resetForm() {
    this.form.reset();
    this.addressInput.value = "";
    this.address = {};
  }

  updateSubmitButtonState() {
    this.submitButtonSpinner.classList.toggle("hidden", !this.submitLoading);
    this.submitButton.disabled = this.submitLoading;
  }

  detachCallback() {
    this.form.removeEventListener("submit", this.validateForm);
    this.submitButton.removeEventListener("click", this.validateForm);
    this.addressInput.removeEventListener("input", this.handleInput);
    this.addressInput.removeEventListener("keydown", this.handleKeydown);
    this.addressInput.removeEventListener("blur", this.hideSuggestions);
    this.addressInput.removeEventListener("focus", this.showSuggestions);
    this.addressSuggestions.removeEventListener("mousedown", this.preventBlur);
  }

  handleInput(e) {
    this.lastPickedAddressId = null;
    this.activeOptionIndex = -1;
    this.updateSuggestions(e.target.value);
    this.addressSuggestions.style.display = "block";
  }

  handleKeydown(e) {
    const options = this.addressSuggestions.querySelectorAll(".option");
    const keyMap = {
      ArrowDown: () => (this.activeOptionIndex = Math.min(this.activeOptionIndex + 1, options.length - 1)),
      ArrowUp: () => (this.activeOptionIndex = Math.max(this.activeOptionIndex - 1, 0)),
      Enter: () => this.activeOptionIndex >= 0 && options[this.activeOptionIndex].click(),
    };

    if (keyMap[e.key]) {
      e.preventDefault();
      keyMap[e.key]();
      this.updateActiveOption(options);
    }
  }

  hideSuggestions() {
    this.addressSuggestions.style.display = "none";
  }

  showSuggestions() {
    if (this.addressInput.value) this.addressSuggestions.style.display = "block";
  }

  preventBlur(e) {
    e.preventDefault();
  }

  async updateSuggestions(address) {
    const caretPosition = this.addressInput.selectionStart;
    const response = await fetch(`/api/dawa/autocomplete?query=${address}&caretPosition=${caretPosition}`);
    const data = await response.json();

    if (data.suggestions.length === 1 && data.suggestions[0].tekst === address) {
      this.hideSuggestions();
      return;
    }

    if (data.successful && data.suggestions.length > 0) {
      this.addressSuggestions.innerHTML = data.suggestions.map((suggestion) => `<div class="option" data-id="${suggestion.id}" data-caretpos="${suggestion.caretpos}">${suggestion.tekst}</div>`).join("");
      this.addressSuggestions.querySelectorAll(".option").forEach((option) => {
        option.addEventListener("click", () => this.selectSuggestion(option));
      });
      this.activeOptionIndex = -1;
      this.storeAddressData(data.suggestions[0].data);
    } else {
      this.addressSuggestions.innerHTML = '<div class="option">Ingen forslag fundet</div>';
    }
  }

  storeAddressData(addressData) {
    this.address = {
      StreetName: addressData.vejnavn,
      HouseNumber: addressData.husnr,
      Floor: addressData.etage ?? null,
      Door: addressData.dør ?? null,
      City: addressData.postnrnavn,
      ZipCode: addressData.postnr,
      XCoordinate: addressData.x ?? null,
      YCoordinate: addressData.y ?? null,
      type: addressData.type ?? null,
    };
  }

  selectSuggestion(option) {
    this.addressInput.value = option.textContent.trim();
    this.addressInput.setSelectionRange(option.dataset.caretpos, option.dataset.caretpos);
    this.updateSuggestions(this.addressInput.value);
  }

  updateActiveOption(options) {
    options.forEach((option, index) => {
      option.classList.toggle("active", index === this.activeOptionIndex);
      if (index === this.activeOptionIndex) {
        requestAnimationFrame(() => option.scrollIntoView({ block: "nearest" }));
      }
    });
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define("activity-form", ActivityForm);
